import { Button, Col, Flex, Row, Tooltip, Typography, theme } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import React from 'react';

const { Text } = Typography;

const MeetingMinute = ({meetingCommonInfo, downloadMeetingMinute,currentCompanyInfo}) => {
    const { colorBgContainer, borderRadiusLG, colorBgLayout } = theme.useToken().token;
    return (
        <>
            {(currentCompanyInfo?.userDetailsId === meetingCommonInfo?.secretaryId || currentCompanyInfo?.userDetailsId === meetingCommonInfo?.assistantSecretaryId) ?
                <>
                    {meetingCommonInfo?.minute && (
                        <div style={{
                            padding: '8px 12px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                            marginBottom: 16
                        }}>
                            {meetingCommonInfo?.minute?.fileName && (
                                <Flex justify='space-between' align='center'>
                                    <span>Added Meeting Minute</span>
                                </Flex>
                            )}
                        </div>
                    )}
                    {meetingCommonInfo?.minute?.fileName && (
                        <Row>
                            <Col span={24}>
                                <Flex gap={20} justify='space-between' align='center' style={{
                                    padding: '16px 24px',
                                    // minHeight: 280,
                                    background: colorBgLayout,
                                    borderRadius: borderRadiusLG,
                                    marginBottom: 16,
                                }}>
                                    <Flex vertical gap={4}>
                                        <Text>{meetingCommonInfo.minute.fileName}</Text>
                                        {/** removed after discussion with roshan and sudath */}
                                        {/* <Text style={{ fontSize: 12 }}  >{formatDate(meetingCommonInfo.info.startDate)} | {formatTime(meetingCommonInfo.info.startDate)} - {formatTime(meetingCommonInfo.info.endDate)}</Text> */}
                                    </Flex>
                                    <Tooltip title="Download Minute">
                                        <Button onClick={downloadMeetingMinute}
                                            type="primary"
                                            icon={<DownloadOutlined />}
                                        // size='small'
                                        />
                                    </Tooltip>
                                </Flex>
                            </Col>
                        </Row>
                    )}
                </>
                : meetingCommonInfo?.meetingStatus === 'minutes' ?
                    <>
                        {meetingCommonInfo?.minute && (
                            <div style={{
                                padding: '8px 12px',
                                background: colorBgContainer,
                                borderRadius: borderRadiusLG,
                                marginBottom: 16
                            }}>
                                {meetingCommonInfo?.minute?.fileName && (
                                    <Flex justify='space-between' align='center'>
                                        <span>Added Meeting Minute</span>
                                    </Flex>
                                )}
                            </div>
                        )}
                        {meetingCommonInfo?.minute?.fileName && (
                            <Row>
                                <Col span={24}>
                                    <Flex gap={20} justify='space-between' align='center' style={{
                                        padding: '16px 24px',
                                        // minHeight: 280,
                                        background: colorBgLayout,
                                        borderRadius: borderRadiusLG,
                                        marginBottom: 16,
                                    }}>
                                        <Flex vertical gap={4}>
                                            <Text>{meetingCommonInfo.minute.fileName}</Text>
                                            {/** removed after discussion with roshan and sudath */}
                                            {/* <Text style={{ fontSize: 12 }}  >{formatDate(meetingCommonInfo.info.startDate)} | {formatTime(meetingCommonInfo.info.startDate)} - {formatTime(meetingCommonInfo.info.endDate)}</Text> */}
                                        </Flex>
                                        <Tooltip title="Download Minute">
                                            <Button onClick={downloadMeetingMinute}
                                                type="primary"
                                                icon={<DownloadOutlined />}
                                            // size='small'
                                            />
                                        </Tooltip>
                                    </Flex>
                                </Col>
                            </Row>
                        )}
                    </>
                    : null
            }
        </>
    )
}

export default MeetingMinute;